/**
 * Create the ESTP legacy key (representative registration spec) according to the flow of the representative registration:
 * ESTP.{documento CPF 11 | CNPJ 14}.{policy number 1–11 digits}.{ramo 1 digit}
 * Policy segment is not left-padded; CADP stores the natural digit length (max 11).
 */
export function padNumApolice11(numApoliceApol: number): string {
  const s = String(Math.trunc(numApoliceApol)).replace(/\D/g, '');
  return s.slice(-11);
}

export function selectedTypeToRamoDigit(type: 'vida' | 'previdencia'): string {
  return type === 'previdencia' ? '5' : '4';
}

export function selectedTypeToOrigemDadoId(type: 'vida' | 'previdencia'): string {
  return type === 'previdencia' ? '0' : '90';
}

export function buildEstpChaveLegado(
  documento: string,
  numApoliceApol: number,
  ramoOneDigit: string
): string {
  const alnum = documento.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  const docSegment = /^\d{11}$/.test(alnum)
    ? alnum
    : alnum.length === 14
      ? alnum
      : alnum.replace(/\D/g, '').padStart(14, '0').slice(-14);
  const ap = padNumApolice11(numApoliceApol);
  const ramo = (ramoOneDigit.replace(/\D/g, '').slice(-1) || '4');
  return `ESTP.${docSegment}.${ap}.${ramo}`;
}

/** Convert policy date (ex.: 01-02-2007) to yyyy-MM-dd accepted by CADP. */
export function policyDateToApiIso(raw: string | undefined, fallback: string): string {
  if (!raw || !raw.trim()) return fallback;
  const s = raw.trim();
  const parts = s.split(/[-/.]/);
  if (parts.length !== 3) return fallback;
  const [a, b, c] = parts;
  if (a.length === 4) {
    return `${a}-${b.padStart(2, '0')}-${c.padStart(2, '0')}`;
  }
  const dd = a.padStart(2, '0');
  const mm = b.padStart(2, '0');
  const yyyy = c.length === 2 ? `20${c}` : c;
  return `${yyyy}-${mm}-${dd}`;
}
